export default __webpack_public_path__ + "assets/462fc972e866c9b890d387d478fe3e4b.png";